import styled from "styled-components";

export const StyledEmailHeaderButtonsWrapper = styled.div<{ top: number }>`
    position: absolute;
    top: ${({ top }) => top}px;
    right: 32px;
    display: flex;
    gap: 8px;
    align-items: center;

    > div {
        position: static;
        top: auto;
        right: auto;
    }
`;
